import BaseRepository from "~/repositories/BaseRepository";
import RecruitModel from "~/models/RecruitModel";

type IndexParams = {
  q?: {
    user_account_user_account_id_eq?: number
  }
}

export default class RecruitsRepository extends BaseRepository {
  async index(params: IndexParams): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = "/api/v1/recruits";
    const results = await this._get(url, params);
    const models = [];
    results.data.forEach(result => {
      models.push(new RecruitModel(result));
    });
    return models;
  }
}
